import { ProductFieldsFragment } from 'graphql/generated/magentoApi';
import { ReactElement } from 'react';
import { rootPath } from 'pages/ProductList';
import './ProductInformation.scss';

type Props = {
  product: ProductFieldsFragment;
};

export default function ProductInformation({ product }: Props): ReactElement {
  const { categories, sku, __typename, vendor_company } = product;

  const filteredCategories =
    categories?.filter(category => {
      if (rootPath) {
        return (
          category?.url_path !== rootPath &&
          category?.url_path?.includes(rootPath)
        );
      }
      return true;
    }) || [];

  return (
    <div className="product-info__container relative">
      <div className="product-info-row">
        <span className="font-bold">Categories: </span>
        <span className="product-info-data">
          {filteredCategories.map(category => category?.name).join(', ')}
        </span>
      </div>
      <div className="product-info-row">
        <span className="font-bold">Vendor: </span>
        <span className="product-info-data">{vendor_company}</span>
      </div>
      <div className="product-info-row">
        <span className="font-bold">Sku: </span>
        <span className="product-info-data">{sku}</span>
      </div>
      <div className="product-info-row">
        <span className="font-bold">Product Type: </span>
        <span className="product-info-data">
          {__typename === 'VirtualProduct'
            ? 'Digital Content'
            : 'Physical Product'}
        </span>
      </div>
    </div>
  );
}
